import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Keyboard } from 'lucide-react';

const KeyboardShortcutsTab = ({ active }) => {
  const navigate = useNavigate();

  return (
    <div className="hidden lg:block shrink-0 border-t border-gray-200 bg-white sticky bottom-0">
      <button
        type="button"
        onClick={() => navigate('/keyboard-shortcuts')}
        className={`w-full flex items-center gap-3 px-3 py-2.5 text-left text-sm transition-colors ${
          active
            ? 'bg-blue-50 text-blue-700 font-semibold'
            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
        }`}
      >
        <Keyboard className={`w-4 h-4 shrink-0 ${active ? 'text-blue-600' : 'text-gray-400'}`} />
        <span>Shortcut keys</span>
      </button>
    </div>
  );
};

export default KeyboardShortcutsTab;
